import request from './crm';

export const clueList = (params = {}) => {
  return request({
    method: 'GET',
    url: '/listForOmp',
    params,
  });
};
